import React, { useRef, useState, useEffect, Suspense } from 'react';
import classnames from 'classnames';

import { FilterContextProvider } from "./context/context";

import { updateFilterUrl } from './helpers/url';
import { filter_items } from './helpers/filters';
import {format_date_datepicker} from './helpers/dates'

const Filters = React.lazy(() => import('./components/Filters'));
const FilterNav = React.lazy(() => import('./components/FilterNav'));
const FilterNavMobile = React.lazy(() => import('./components/FilterNavMobile'));
const TopFilter = React.lazy(() => import('./components/TopFilter'));
const ListView = React.lazy(() => import('./components/ListView'));
const FilterTotals = React.lazy(() => import('./components/FilterTotals'));


const FilterUI = props => {
  const {
    items,
    filterForm,
    topFilterForm,
    filterSettings,
    language
  } = props;
  

  const isInitialMount = useRef(true);
  
  const pagination = filterSettings.pagination;
  const allForms = [...filterForm, topFilterForm];
  const [filterNav, setFilterNav] = useState(allForms);
  const [totalItems, setTotalItems] = useState(props.items.length);
  const [filterView, setFilterView] = useState(filterSettings.currentView);
  const [activeFilters, setActiveFilters] = useState(filterSettings.activeFilters);


  const [currentPage, setCurrentPage] = useState(filterSettings.pagination.currentPage);
  const [navStatus, setNavStatus] = useState(false);
  const [currentY, setCurrentY] = useState(0);
  const [initialY, setInitialY] = useState(0);
  const [yOffset, setYOffset] = useState(0);
  const [dragStyle, setDragStyle] = useState({transform: "translate3d(" + 0 + "px, " + 0 + "px, 0)"})

  const [startDate, setStartDate] = useState(filterSettings.activeFilters.calendar ? filterSettings.activeFilters.calendar.value[0] : false);
  const [endDate, setEndDate] = useState(filterSettings.activeFilters.calendar ? filterSettings.activeFilters.calendar.value[1] : false);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [topFilter, setTopFilter] = useState(topFilterForm);
  const [startDateFormatted, setStartDateFormatted] = useState(format_date_datepicker(startDate))
  const [endDateFormatted, setEndDateFormatted] = useState(format_date_datepicker(endDate))

  const [mobileMenu, setMobileMenu] = useState(false);
  const [topMobileMenu, setTopMobileMenu] = useState(false);
  const [dateQuickLink, setDateQuickLink] = useState(false);
  const [availability, setAvailability] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchEventAvailability = async () => {
      var events = [];
      items.forEach(item => {
        events.push(item.event_hash);
      })
      try {
        const response = await fetch(base_url + 'ajax/check_event_availability/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ events }),
        });
        const data = await response.json();

        if (data.availability) {
          const parsedAvailability = JSON.parse(data.availability);
          setAvailability(parsedAvailability);
          console.log(parsedAvailability)
        }
      } catch (error) {
        console.error('Error fetching event availability:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchEventAvailability();
  }, [items]);



  let now = Date.now();
  if (typeof activeFilters.calendar != "undefined"){
    if (activeFilters.calendar.value[0]){
      now = new Date(activeFilters.calendar.value[0]).getTime();
    }
  }


  //Sorting items by performance time
  items.forEach((item) => {
    if (typeof item.performance_times != "undefined"){
      if (!item.performance_times.length){
        item.performance_times.push(item.start_date);
      }
      //sort performance times as they are sometimes added not in right order
      item.performance_times.sort((a,b) => (a > b) ? 1 : ((b > a) ? -1 : 0))

      let next_performance_time = item.performance_times.find(time => (time * 1000) >= now);
      if (typeof next_performance_time != "undefined"){
        item.next_performance_time = next_performance_time * 1000
      } else {
        item.next_performance_time = 0;
      }
    } else {
      item.next_performance_time = 0;
    }
  });

  items.sort((a,b) => (a.next_performance_time > b.next_performance_time) ? 1 : ((b.next_performance_time > a.next_performance_time) ? -1 : 0))

  const [allItems, setAllItems] = useState(items);
  const [filteredItems, setFilteredItems] = useState(items);

  const states = {availability, setAvailability, dateQuickLink, setDateQuickLink, topMobileMenu, setTopMobileMenu, mobileMenu, setMobileMenu, startDateFormatted, setStartDateFormatted, endDateFormatted, setEndDateFormatted, topFilter, setTopFilter, startDateOpen, setStartDateOpen, endDateOpen, setEndDateOpen, startDate, setStartDate, endDate, setEndDate, currentY, setCurrentY,initialY, setInitialY, yOffset, setYOffset,dragStyle, setDragStyle, allItems, setAllItems, filterView, setFilterView, filterNav, setFilterNav, activeFilters, setActiveFilters, totalItems, setTotalItems, filteredItems, setFilteredItems, pagination, currentPage, setCurrentPage,language, navStatus, setNavStatus};


  const viewResults = () => {
    let updatedFilterNav = [...filterNav];
    updatedFilterNav.map((nav, i) => {
      nav.open = false;
    })
    setFilterNav(updatedFilterNav);
    setNavStatus(false);
    setMobileMenu(false);
    setTopMobileMenu(false);
    const body = document.querySelector('body');
    body.classList.remove('filters-open');

    let container = document.querySelector('.filter-block'),
          template = document.querySelector('.template'),
          template_height = template.offsetHeight,
          pos = container.offsetTop;

    window.scrollTo(0, template_height + pos - 100)
  }

  const updateItems = () => {
    const results = filter_items(items, activeFilters, filterView);
    setTotalItems(results.length);

    if (typeof activeFilters.calendar != "undefined"){
      if (activeFilters.calendar.value[0]){
        let now = new Date(activeFilters.calendar.value[0]).getTime();
        results.forEach((item) => {
          if (typeof item.performance_times != "undefined"){
            item.performance_times.sort((a,b) => (a > b) ? 1 : ((b > a) ? -1 : 0))

            let next_performance_time = item.performance_times.find(time => (time * 1000) >= now);
            if (typeof next_performance_time != "undefined"){
              item.next_performance_time = next_performance_time * 1000
            } else {
              item.next_performance_time = 0;
            }
          } else {
            item.next_performance_time = 0;
          }
        });
        results.sort((a,b) => (a.next_performance_time > b.next_performance_time) ? 1 : ((b.next_performance_time > a.next_performance_time) ? -1 : 0))
      }
    }


    setFilteredItems(results);
    let totalPageCount = Math.ceil(results.length / pagination.perpage);
    if (currentPage > totalPageCount ){
      setCurrentPage(totalPageCount > 0 ? totalPageCount : 1);
    }
    updateFilterUrl(activeFilters, currentPage, filterView);

  }

  const setItems = () => {
    const results = filter_items(items, activeFilters, filterView);
    setTotalItems(results.length);
    setFilteredItems(results);

  }


  const clearAllFilters = () => {
    const a = {...activeFilters};
    let es = document.getElementById("events-search");
    if (es) {
      es.value = '';
    }
    for (const key in a) {
      if (a[key].position !== "top"){
        if (typeof a[key].value == "object") {
          if (a[key].name == "calendar"){
            a[key].value = [false, false];

          } else {
            a[key].value = [];
            a[key].selectedTitles = [];
          }
        } else {
          a[key].value = "";
        }
      }
    }
    setStartDate(false);
    setStartDateFormatted('Date');
    setEndDate(false);
    setEndDateFormatted('Date');
    setTopFilter(topFilterForm);
    setDateQuickLink(false);
    setActiveFilters(a);
  }

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      updateItems();
    }
  }, [activeFilters, currentPage]);

  useEffect(() => {
    setItems();
  }, [items]);

  return (
    <>

      <FilterContextProvider value={states}>
      <div className="block-filters-outer">
      <div className="block-filters-inner">
        <div
          className={classnames('filter-bg', {
            active: navStatus,
            active_mobile: mobileMenu || topMobileMenu
          })}
          onClick={() => viewResults()}></div>

        <FilterNavMobile topFilter={topFilterForm} clearAllFilters={clearAllFilters} />


        <div
        style={dragStyle}
        id="drag_container"
        className={classnames('block-filters', {
          active: navStatus
        })}
        >
            <div className="filters">
              <div className="filter-nav-container">
                <FilterNav filterForm={filterForm} clearAllFilters={clearAllFilters}/>
              </div>
            </div>
          <div className="block-filters-container">
            <Filters filterForm={filterForm}  clearAllFilters={clearAllFilters}/>
          </div>

        </div>

        <Suspense>
         <div className="block-filter-views">

              <TopFilter />
              <div className="container">

               <div className="block-filter-views-inner">

                <ListView />

                </div>
              </div>

          </div>

        </Suspense>
        </div>
        </div>
        <div
        className={classnames('fixed-filter-actions', {
          active: navStatus || mobileMenu || topMobileMenu
        })}
        >
          <div className="fixed-filter-actions-totals">
            <FilterTotals />
          </div>
          <div className="fixed-filter-actions-buttons">
            <button onClick={() => viewResults()}  className="button button-ochre">See Results</button>
            <button onClick={() => clearAllFilters()} className="button button-transparent">Clear all filters</button>

          </div>

        </div>
      </FilterContextProvider>

    </>
  );
}
export default FilterUI;
